export default () => ({
  checkingResetPasswordToken: false,
  identification: localStorage.getItem('_i') || '',
  logging: false,
  registerForm: {},
  registering: false,
  resending: false,
  sendingForgetPwdLink: false,
  sendingResetPwdLink: false,
  token: localStorage.getItem('_t') || '',
  updatingUser: false,
  role: null,
});
